import _orderBy from 'lodash/orderBy'
import {
  getGembaWalkAllRelatedCheckpoints,
  getGembaWalkCategories,
  getGembaWalkCheckpointById,
  getGembaWalkCheckpoints,
  getGembaWalkKpis,
} from 'frontend/communications/gembaWalk'
import { sortAlphabetically } from 'frontcore/utils/helpers/formatters'

const stateObj = {
  categories: [],
  checkpoints: [],
  kpis: [],
}

const storeGetters = {
  getGembaWalkCheckpoints (state) {
    return state.checkpoints
  },
  getGembaWalkCheckpointsByPerimeters: (state) => (perimeterIds) => {
    return state.checkpoints.filter(checkpoint =>
      perimeterIds.some(perimeter => checkpoint.perimeters.includes(perimeter)) ||
      checkpoint.perimeters.length === 0
    )
  },
  getGembaWalkCheckpointById: (state) => (id) => {
    return state.checkpoints.find(checkpoint => checkpoint.id === id)
  },
  getGembaWalkCategories (state) {
    return state.categories
  },
  getGembaWalkCategoryById: (state) => (id) => {
    return state.categories.find(category => category.id === id)
  },
  getActiveGembaWalkCategories (state) {
    return state.categories.filter(category => {
      return category.enabled
    }).sort(
      sortAlphabetically('name')
    )
  },
  getGembaWalkKpisById: (state) => (id) => {
    return state.kpis.find(kpi => kpi.id === id)
  },
  getActiveGembaWalkKpis (state) {
    return state.kpis.filter(kpi => {
      return kpi.enabled
    }).sort(
      sortAlphabetically('name')
    )
  },
}

const mutations = {
  setGembaWalkCategories (state, categories) {
    state.categories = _orderBy(categories, 'id')
  },
  setGembaWalkCheckpoints (state, checkpoints) {
    state.checkpoints = _orderBy(checkpoints, 'description')
  },
  addGembaWalkCheckpoints (state, value) {
    const index = state.checkpoints.findIndex(checkpoint => checkpoint.id == value.id)
    index >= 0 ? state.checkpoints.splice(index, 1, value) : state.checkpoints.push(value)
  },
  removeGembaWalkCheckpoints (state, gembaWalkCheckpointID) {
    state.checkpoints = state.checkpoints.filter(checkpoint => checkpoint.id !== gembaWalkCheckpointID)
  },
  setGembaWalkKpis (state, kpis) {
    state.kpis = _orderBy(kpis, 'id')
  },
  setGembaWalkCheckpointCreators (state, creators) {
    state.checkpointCreators = creators
  },
  updateGembaWalkCategory (state, value) {
    const categoryIndex = state.categories.findIndex(category => category.id === value.id)
    if (categoryIndex !== -1) {
      state.categories.splice(categoryIndex, 1, value)
    }
  },
  updateGembaWalkKpi (state, value) {
    const categoryIndex = state.kpis.findIndex(kpi => kpi.id === value.id)
    if (categoryIndex !== -1) {
      state.kpis.splice(categoryIndex, 1, value)
    }
  },
}

const actions = {
  fetchGembaWalkCategories ({ commit }) {
    return getGembaWalkCategories()
      .then((categories) => {
        commit('setGembaWalkCategories', categories)
      })
  },
  fetchGembaWalkCheckpoints ({ commit }) {
    return getGembaWalkCheckpoints().then(checkpoints => {
      commit('setGembaWalkCheckpoints', checkpoints)
    })
  },
  fetchGembaWalkAllRelatedCheckpoints ({ commit }, perimeterId) {
    return getGembaWalkAllRelatedCheckpoints(perimeterId).then(checkpoints => {
      commit('setGembaWalkCheckpoints', checkpoints)
    })
  },
  fetchGembaWalkCheckpointById ({ commit, getters }, id) {
    const storedCheckpoint = getters.getGembaWalkCheckpointById(id)
    if (storedCheckpoint) {
      return Promise.resolve(storedCheckpoint)
    }
    return getGembaWalkCheckpointById(id)
      .then((checkpoint) => {
        commit('addGembaWalkCheckpoints', checkpoint)
        return checkpoint
      })
  },
  fetchGembaWalkKpis ({ commit }) {
    return getGembaWalkKpis()
      .then((kpis) => {
        commit('setGembaWalkKpis', kpis)
      })
  },
}

export default {
  actions,
  getters: storeGetters,
  mutations,
  state: stateObj,
}
